export type Density = "compact" | "cozy" | "spacious";

export const DENSITY_OPTIONS: Density[] = ["compact", "cozy", "spacious"];

export const DENSITY_LABELS: Record<Density, string> = {
  compact: "SM",
  cozy: "MD",
  spacious: "LG",
};

export interface DensityStyles {
  rowGap: string;
  rowPad: string;
  thumb: string;
  textGap: string;
  name: string;
  meta: string;
  price: string;
  insured: string;
}

export const DENSITY_STYLES: Record<Density, DensityStyles> = {
  compact: {
    rowGap: "gap-3",
    rowPad: "px-4 py-2.5",
    thumb: "w-20",
    textGap: "gap-1",
    name: "text-sm font-medium",
    meta: "text-xs",
    price: "text-base font-semibold",
    insured: "text-[10px]",
  },
  cozy: {
    rowGap: "gap-4",
    rowPad: "px-4 py-3",
    thumb: "w-28",
    textGap: "gap-1.5",
    name: "text-base font-semibold",
    meta: "text-sm",
    price: "text-lg font-semibold",
    insured: "text-xs",
  },
  spacious: {
    rowGap: "gap-5",
    rowPad: "px-5 py-4",
    thumb: "w-40",
    textGap: "gap-2",
    name: "text-lg font-semibold",
    meta: "text-base",
    price: "text-2xl font-semibold",
    insured: "text-sm",
  },
};
